export const CONSENT_COOKIE = 'evoo_consent';
export const CONSENT_POLICY_VERSION = '25.10.2026';
export const OPEN_COOKIE_SETTINGS_EVENT = 'evoo:open-cookie-settings';

const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 182; // ~6 luni, conform politicii
const GA_MEASUREMENT_ID = 'G-8G3XK6M0P4';
const CONSENT_API_URL = `${process.env.REACT_APP_SERVER_URL || ''}/api/v1/consent`;

function createConsentId() {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getStoredConsent() {
    const entry = document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith(`${CONSENT_COOKIE}=`));
    if (!entry) return null;
    try {
        return JSON.parse(decodeURIComponent(entry.slice(CONSENT_COOKIE.length + 1)));
    } catch {
        return null;
    }
}

function removeAnalyticsCookies() {
    document.cookie.split('; ').forEach((cookie) => {
        const name = cookie.split('=')[0];
        if (name === '_ga' || name.startsWith('_ga_')) {
            document.cookie = `${name}=; max-age=0; path=/`;
        }
    });
}

let analyticsLoaded = false;

function loadGoogleTag() {
    if (analyticsLoaded) return;
    analyticsLoaded = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
}

export function trackGoogleEvent(name, params) {
    if (analyticsLoaded && typeof window.gtag === 'function') {
        window.gtag('event', name, params);
    }
}

export function applyAnalyticsConsent(analytics) {
    if (analytics) {
        window.gtag('consent', 'update', { analytics_storage: 'granted' });
        loadGoogleTag();
    } else {
        window.gtag('consent', 'update', { analytics_storage: 'denied' });
        removeAnalyticsCookies();
    }
}

function logConsent(consent) {
    fetch(CONSENT_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            consentId: consent.id,
            choice: consent.choice,
            analytics: consent.analytics,
            policyVersion: consent.policyVersion,
        }),
        keepalive: true,
    }).catch(() => {
        // Jurnalul de pe server este best-effort; alegerea rămâne salvată în browser.
    });
}

export function saveConsent({ analytics, choice }) {
    const consent = {
        id: createConsentId(),
        choice,
        analytics,
        policyVersion: CONSENT_POLICY_VERSION,
        date: new Date().toISOString(),
    };

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
        `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(consent))}; ` +
        `max-age=${CONSENT_MAX_AGE_SECONDS}; path=/; SameSite=Lax${secure}`;

    logConsent(consent);
    applyAnalyticsConsent(analytics);
    return consent;
}
